export const PRO_RESOURCES_DIRTY_EVENT = "sill:pro-resources-dirty";

export type ProResourcesDirtyDetail = {
  resources: string[];
};

export function emitProResourcesDirty(resources: string[]) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ProResourcesDirtyDetail>(PRO_RESOURCES_DIRTY_EVENT, {
      detail: { resources },
    }),
  );
}
